import { Alert, Stack } from "@mui/material"
import { useDashboardStore } from "../../stores/dashboard/dashboard"
import { StyledDataGrid } from "../../common/components/styled_data_grid"
import { GridColDef } from "@mui/x-data-grid-pro"
import { useMemo } from "react"

import RefreshButton from "../../components/global/RefreshButton"

function Dashboard() {
  const { selectedModule, setSelectedModule, loadingDashboard, erroDashboard, messageErro, dashboardHome } = useDashboardStore()

  const columns = useMemo((): GridColDef[] => [
    {
      field: "dia",
      filterable: false,
      headerName: "Dia",
      sortable: false,
      headerClassName: 'funcionarios-header',
      width: 30,
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header'
    },
    {
      field: "setor",
      filterable: false,
      headerName: "Setor",
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueGetter: (value) => {
        return value ? value : "-"
      },
    },
  ], [

  ]);

  /*
  */

  return (
    <div className="flex w-full gap-2 flex-col py-2 px-4 mb-10">
      <div className="flex gap-2 items-center">
        <h1 className="text-3xl font-medium text-black dark:text-white">Dashboard</h1>
        <RefreshButton onClick={async () => {
          await setSelectedModule(0)
        }} />
      </div>
      <div>
      </div>
      {
        erroDashboard === true &&
        <Alert severity="error">{messageErro}</Alert>
      }
      <div className="w-full flex justify-center">
        {
          (selectedModule === 0 && dashboardHome != null) &&
          <div className="w-full flex flex-col gap-4">
            <Stack spacing={2}>
              <h1 className="font-medium text-xl text-black dark:text-white">Aniversariantes do Mês</h1>
              <StyledDataGrid
                tableName='dashboard-home-aniversariantes'
                height="80vh"
                getRowId={(row) => row.idFuncionario}
                columns={columns}
                loading={loadingDashboard}
                rows={dashboardHome.item.aniversariantes}
              />
            </Stack>
          </div>
        }
      </div>
    </div>
  )
}

export default Dashboard
